var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-test":"logout__page"}},[_vm._v("Déconnexion...")])
}
var staticRenderFns = []

export { render, staticRenderFns }